/* 7 O'CLOCK – Bloom Mix & Match (sections/7oc-mix-match.liquid), 05.10.2026
   Auswahl Strauß + Vase, Setpreis/Ersparnis live, beide Originalvarianten gemeinsam in den Warenkorb
   (Cart-API, gemeinsame Paar-ID in _mm_pair). Vanilla JS, keine Libraries.
   Rabatt-Logik (06.10.2026): PCT % auf Strauß UND Vase – passend zum automatischen Shopify-Rabatt
   „Mix & Match -10 %“ (10 % auf beide Kollektionen ab 2 Teilen im Warenkorb). */
(function () {
  'use strict';

  var root = document.querySelector('[data-oc-mm]');
  if (!root) return;

  var PCT = parseInt(root.getAttribute('data-percent'), 10) || 0;
  var SET_NAME = root.getAttribute('data-set-name') || 'Mix & Match';
  var PAGE_SIZE = 40; /* Karten pro Ladung, danach „Weitere anzeigen“ (Alina, 05.10.2026) */
  var ROLES = ['strauss', 'vase'];
  var ROLE_LABEL = { strauss: 'Strauß', vase: 'Vase' };
  var FREE_SHIP = 6900; /* Cent – versandkostenfrei ab 69 € (DE) */
  function geoCountry() {
    try { if (window.ocPromo && window.ocPromo.geoCountry) return window.ocPromo.geoCountry(); } catch (e) {}
    try { return sessionStorage.getItem('oc-geo-country') || 'DE'; } catch (e) { return 'DE'; }
  }

  var products = [];
  try { products = JSON.parse(root.querySelector('[data-oc-mm-products]').textContent); } catch (e) { products = []; }
  products.forEach(function (p) { if (typeof p.subline !== 'string') p.subline = ''; });

  var state = {
    sel: { strauss: null, vase: null },       /* { product, variant } */
    shown: { strauss: PAGE_SIZE, vase: PAGE_SIZE },
    step: 'strauss',
    busy: false,
    preselecting: false,
    filter: { strauss: '', vase: '' }          /* aktive Pill (Kollektions-Handle) je Schritt */
  };

  /* ---------- Helpers ---------- */
  function qs(s, el) { return (el || root).querySelector(s); }
  function qsa(s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); }
  function money(cents) {
    var n = Math.round(cents) / 100;
    return n.toFixed(2).replace('.', ',') + ' €';
  }
  /* Rabattbetrag wie Shopify: auf volle Cent abgerundet (49,99 € → 4,99 € Rabatt → 45,00 €) */
  function setPrice(cents) { return cents - Math.floor(cents * PCT / 100); }
  function firstAvailable(p) {
    for (var i = 0; i < p.variants.length; i++) if (p.variants[i].available) return p.variants[i];
    return p.variants[0] || null;
  }
  /* Name/Detail aus dem Produkttitel ableiten („Pure Fern 13er Bouquet in Weiß & Grün | Bloom“) */
  function nameOf(p) {
    if (p.role === 'strauss') {
      var m = p.main.match(/^(.*?)\s+(\d+)er\s+Bouquet(?:\s+in\s+(.*))?$/i);
      if (m) return { name: m[1], detail: m[3] || '', sub: m[2] + ' Stiele' };
      return { name: p.main, detail: '', sub: p.subline || '' };
    }
    /* Vasen: keine Subline („1er Set“) auf der Karte (Alina, 05.10.2026) */
    if (p.series) return { name: p.series, detail: p.main.replace(/\s*\|.*$/, ''), sub: '' };
    return { name: p.main, detail: '', sub: '' };
  }

  /* ---------- Karten rendern ---------- */
  var tpl = qs('[data-oc-mm-card]');

  function renderGrid(role) {
    var grid = qs('[data-oc-mm-grid="' + role + '"]');
    var list = products.filter(function (p) { return p.role === role; });
    grid.innerHTML = '';
    list.forEach(function (p, i) {
      var node = tpl.content.firstElementChild.cloneNode(true);
      var nd = nameOf(p);
      var v = firstAvailable(p);
      node.setAttribute('data-id', p.id);
      node.setAttribute('aria-pressed', 'false');
      node.setAttribute('aria-label', nd.name);
      buildGallery(node, p, i < 4);
      qs('.oc-mm_card-name', node).textContent = nd.name;
      qs('.oc-mm_card-detail', node).textContent = nd.detail;
      qs('.oc-mm_card-sub', node).textContent = nd.sub;
      if (!p.available || !v) {
        node.classList.add('is-soldout');
        node.setAttribute('aria-disabled', 'true');
        node.removeAttribute('tabindex');
        qs('.oc-mm_card-soldout', node).hidden = false;
        qs('.oc-mm_card-price', node).hidden = true;
        qs('.oc-mm_card-setlbl', node).hidden = true;
      } else {
        /* Strauß und Vase: Setpreis (−PCT %) + Streichpreis */
        qs('.oc-mm_card-was', node).textContent = money(v.price);
        qs('.oc-mm_card-set', node).textContent = money(setPrice(v.price));
      }
      node.addEventListener('click', function () { select(role, p, node); });
      node.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(role, p, node); }
      });
      grid.appendChild(node);
    });
    applyFilter(role);
  }

  /* Bildgalerie in der Karte: alle Produktbilder, seitlich wischbar, kleine Punkte im unteren Bildbereich (Alina, 05.10.2026) */
  function buildGallery(node, p, eager) {
    var track = qs('[data-oc-mm-track]', node);
    var dots = qs('[data-oc-mm-dots]', node);
    var list = (p.images || []).slice();
    if (!list.length || list[0].s !== p.image) list.unshift({ s: p.image, l: p.image2x, alt: p.imageAlt }); /* eigenes Mix & Match-Bild zuerst */
    list.forEach(function (im, i) {
      var img = document.createElement('img');
      img.src = im.s; img.srcset = im.s + ' 1x, ' + im.l + ' 2x'; img.alt = im.alt || p.imageAlt;
      img.loading = (eager && i === 0) ? 'eager' : 'lazy';
      img.draggable = false;
      track.appendChild(img);
      if (list.length > 1) {
        var d = document.createElement('span');
        d.className = 'oc-mm_card-dot' + (i === 0 ? ' is-active' : '');
        dots.appendChild(d);
      }
    });
    if (list.length < 2) { dots.hidden = true; return; }
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        qsa('.oc-mm_card-dot', dots).forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      });
    }, { passive: true });
  }

  /* Wisch-Hinweis (Alina, 05.10.2026): beim ersten Sichtbarwerden eines Schritts schiebt sich bei der
     rechten Karte der ersten Reihe das Bild bis zur Hälfte zur Seite und wieder zurück – einmal pro Seitenaufruf. */
  var hinted = { strauss: false, vase: false };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function hintCard(role) {
    var grid = qs('[data-oc-mm-grid="' + role + '"]');
    var cards = qsa('.oc-mm_card:not(.is-hidden)', grid);
    if (!cards.length) return null;
    var cols = (getComputedStyle(grid).gridTemplateColumns || '').split(' ').filter(Boolean).length || 2;
    return cards[Math.min(cols, cards.length) - 1];
  }
  function peekHint(role) {
    if (hinted[role] || reduceMotion) return;
    var card = hintCard(role);
    var track = card && qs('[data-oc-mm-track]', card);
    if (!track || track.scrollWidth <= track.clientWidth + 2) return;
    hinted[role] = true;
    var dist = track.clientWidth * 0.5, out = 480, hold = 220, back = 480, start = null;
    var ease = function (t) { return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t; };
    track.style.scrollSnapType = 'none';
    function frame(ts) {
      if (start === null) start = ts;
      var t = ts - start, x;
      if (t < out) x = dist * ease(t / out);
      else if (t < out + hold) x = dist;
      else if (t < out + hold + back) x = dist * (1 - ease((t - out - hold) / back));
      else { track.scrollLeft = 0; track.style.scrollSnapType = ''; return; }
      track.scrollLeft = x;
      requestAnimationFrame(frame);
    }
    setTimeout(function () { requestAnimationFrame(frame); }, 500);
  }
  function watchHint(role) {
    var card = hintCard(role);
    if (!card) return;
    if (!('IntersectionObserver' in window)) { peekHint(role); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { io.disconnect(); peekHint(role); } });
    }, { threshold: 0.6 });
    io.observe(card);
  }

  /* Pills: ohne Filter 8 Karten + „Weitere anzeigen“, mit Filter alle passenden Karten */
  function applyFilter(role) {
    var f = state.filter[role];
    var cards = qsa('[data-oc-mm-grid="' + role + '"] .oc-mm_card');
    var list = products.filter(function (p) { return p.role === role; });
    var visible = 0;
    cards.forEach(function (c, i) {
      var p = list[i];
      var match = !f || (p.colls || []).indexOf(f) !== -1;
      var show = match && (f ? true : i < state.shown[role]);
      c.classList.toggle('is-hidden', !show);
      if (show) visible++;
    });
    var more = qs('[data-oc-mm-more="' + role + '"]');
    more.hidden = !!f || list.length <= state.shown[role];
    var empty = qs('[data-oc-mm-empty="' + role + '"]');
    if (empty) empty.hidden = visible > 0;
  }

  qsa('[data-oc-mm-pill]').forEach(function (b) {
    b.addEventListener('click', function () {
      var wrap = b.closest('[data-oc-mm-pills]');
      var role = wrap.getAttribute('data-oc-mm-pills');
      state.filter[role] = b.getAttribute('data-oc-mm-pill') || '';
      qsa('[data-oc-mm-pill]', wrap).forEach(function (x) { x.classList.toggle('is-active', x === b); });
      applyFilter(role);
    });
  });

  function select(role, p, node) {
    if (!p.available) return;
    var cur = state.sel[role];
    if (cur && cur.product.id === p.id) return;
    var v = firstAvailable(p);
    state.sel[role] = { product: p, variant: v };
    qsa('[data-oc-mm-grid="' + role + '"] .oc-mm_card').forEach(function (c) {
      var on = c === node;
      c.classList.toggle('is-selected', on);
      c.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    renderVariants(role, node);
    update();
    if (role === 'strauss') qs('[data-oc-mm-next]').hidden = false;
    /* Nach der Wahl direkt zum fehlenden Schritt springen (Alina, 05.10.2026):
       Strauß gewählt → Vase; Vase ohne Strauß gewählt → Strauß. Kurze Pause, damit die Auswahl sichtbar wird. */
    var other = role === 'strauss' ? 'vase' : 'strauss';
    /* Vorauswahl per URL (vom Produktseiten-Banner): Seite startet oben beim Strauß-Schritt, kein Sprung zur Vase */
    if (state.preselecting) return;
    if (!state.sel[other]) setTimeout(function () { goTo(other, true); }, 350);
    else setTimeout(openSummary, 350);
  }

  /* ---------- Zusammenfassung (06.10.2026) ----------
     Sobald Strauß + Vase gewählt sind: nach oben scrollen, die Kaufleiste öffnet sich als Sheet (mobil bis ca. 60 % der Höhe)
     mit beiden Bildern, Namen, Preis und Button; dahinter wird die Seite abgedunkelt. „Auswahl ändern“, Tipp auf die
     Abdunkelung oder jeder Schrittwechsel schließt das Sheet wieder. */
  function openSummary() {
    var s = state.sel.strauss, v = state.sel.vase;
    if (!s || !v) return;
    ROLES.forEach(function (role) {
      var sel = state.sel[role];
      var box = qs('[data-oc-mm-sum="' + role + '"]');
      var img = qs('[data-oc-mm-sum-img]', box);
      img.src = sel.product.image; img.srcset = sel.product.image + ' 1x, ' + sel.product.image2x + ' 2x'; img.alt = sel.product.imageAlt;
      var nd = nameOf(sel.product);
      qs('[data-oc-mm-sum-name]', box).textContent = nd.name;
      qs('[data-oc-mm-sum-sub]', box).textContent = [(sel.variant && sel.variant.title !== 'Default Title' ? sel.variant.title : ''), nd.detail, nd.sub].filter(Boolean).join(' · ');
    });
    qs('[data-oc-mm-summary]').hidden = false;
    qs('[data-oc-mm-backdrop]').hidden = false;
    qs('[data-oc-mm-bar]').classList.add('is-open');
    var y = root.getBoundingClientRect().top + window.scrollY - stickyOffset() - 8;
    window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
  }
  function closeSummary() {
    var bar = qs('[data-oc-mm-bar]');
    if (!bar.classList.contains('is-open')) return;
    bar.classList.remove('is-open');
    qs('[data-oc-mm-summary]').hidden = true;
    qs('[data-oc-mm-backdrop]').hidden = true;
  }
  qs('[data-oc-mm-summary-change]').addEventListener('click', function () { closeSummary(); });
  qs('[data-oc-mm-backdrop]').addEventListener('click', function () { closeSummary(); });

  /* Varianten-Pills unter der gewählten Karte (nur bei echter Auswahl) */
  function renderVariants(role, node) {
    var grid = qs('[data-oc-mm-grid="' + role + '"]');
    var old = qs('.oc-mm_variants', grid);
    if (old) old.remove();
    var s = state.sel[role];
    if (!s || s.product.onlyDefault || s.product.variants.length < 2) return;
    var box = document.createElement('div');
    box.className = 'oc-mm_variants';
    var lbl = document.createElement('span');
    lbl.className = 'oc-mm_variants-lbl';
    lbl.textContent = (s.product.options || []).join(' / ') + ' für ' + nameOf(s.product).name + ' wählen:';
    box.appendChild(lbl);
    s.product.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'oc-mm_variant' + (v.id === s.variant.id ? ' is-active' : '');
      b.textContent = v.title + ' · ' + money(v.price);
      b.disabled = !v.available;
      b.addEventListener('click', function () {
        s.variant = v;
        qsa('.oc-mm_variant', box).forEach(function (x) { x.classList.toggle('is-active', x === b); });
        update();
      });
      box.appendChild(b);
    });
    /* hinter der Karte einfügen (volle Breite) */
    node.insertAdjacentElement('afterend', box);
  }

  /* ---------- Anzeige aktualisieren ---------- */
  function update() {
    var s = state.sel.strauss, v = state.sel.vase;
    var complete = !!(s && v);

    ROLES.forEach(function (role) {
      var sel = state.sel[role];
      var slot = qs('[data-oc-mm-slot="' + role + '"]');
      var img = qs('[data-oc-mm-slot-img]', slot);
      var empty = qs('[data-oc-mm-slot-empty]', slot);
      var name = qs('[data-oc-mm-slot-name]', slot);
      var change = qs('.oc-mm_slot-change', slot);
      var tab = qs('[data-oc-mm-tab="' + role + '"]');
      if (sel) {
        img.src = sel.product.image; img.srcset = sel.product.image + ' 1x, ' + sel.product.image2x + ' 2x'; img.alt = sel.product.imageAlt; img.hidden = false;
        empty.hidden = true;
        var nd = nameOf(sel.product);
        name.textContent = [nd.name, (sel.variant && sel.variant.title !== 'Default Title' ? sel.variant.title : ''), nd.detail, nd.sub].filter(Boolean).join(' · ');
        name.classList.remove('is-empty');
        change.hidden = false;
        tab.classList.add('is-done');
      } else {
        img.hidden = true; empty.hidden = false;
        name.textContent = 'Noch nicht gewählt'; name.classList.add('is-empty');
        change.hidden = true;
        tab.classList.remove('is-done');
      }
    });

    var bar = qs('[data-oc-mm-bar]');
    var live = qs('[data-oc-mm-live]');
    var sum = (s ? s.variant.price : 0) + (v ? v.variant.price : 0);
    var set = (s ? setPrice(s.variant.price) : 0) + (v ? setPrice(v.variant.price) : 0);
    var saving = sum - set;

    qs('[data-oc-mm-saving]').textContent = money(saving);
    qs('[data-oc-mm-saving-big]').textContent = money(saving);
    qs('[data-oc-mm-total]').textContent = sum ? money(set) : '–';
    qs('[data-oc-mm-total-was]').textContent = sum ? money(sum) : '';
    live.hidden = !(s || v);
    /* „Versandkostenfrei“ nur bei komplettem Set ab 69 € und Besucher:innen in Deutschland (Geo wie custom-promo.js) */
    var ship = qs('[data-oc-mm-ship]');
    if (ship) ship.hidden = !(complete && set >= FREE_SHIP && geoCountry() === 'DE');

    bar.classList.toggle('is-complete', complete);
    bar.classList.toggle('is-empty', !s && !v);
    var missing = qs('[data-oc-mm-missing]');
    if (!s && !v) missing.textContent = 'Wähle Strauß und Vase – dann siehst du deinen Setpreis.';
    else if (!v) missing.textContent = 'Fast geschafft: Wähle jetzt deine Vase – im Bundle ' + PCT + ' % günstiger.';
    else if (!s) missing.textContent = 'Wähle noch deinen Strauß – im Bundle ' + PCT + ' % günstiger.';
    /* Button bleibt klickbar: bei fehlendem Teil führt er zum passenden Schritt (Alina, 05.10.2026) */
    qs('[data-oc-mm-add]').disabled = state.busy;
    qs('[data-oc-mm-cta-label]').textContent = complete ? 'Kombination in den Warenkorb' : (s ? 'Vase wählen' : 'Strauß wählen');
    qs('[data-oc-mm-error]').hidden = true;
  }

  /* ---------- Schritte ---------- */
  /* Höhe des fixierten Headers (Announcement + Navigation), damit die Tabs nach dem Scroll sichtbar bleiben */
  function stickyOffset() {
    var max = 0;
    qsa('body > *, body > * > *', document).forEach(function (el) {
      var cs = getComputedStyle(el);
      if ((cs.position === 'fixed' || cs.position === 'sticky') && el.getBoundingClientRect().top <= 1 && !el.classList.contains('oc-mm_bar')) {
        var r = el.getBoundingClientRect();
        if (r.height < window.innerHeight * 0.6) max = Math.max(max, r.bottom);
      }
    });
    return max;
  }
  function goTo(step, scroll) {
    closeSummary();
    state.step = step;
    ROLES.forEach(function (r) {
      qs('[data-oc-mm-tab="' + r + '"]').classList.toggle('is-active', r === step);
      qs('[data-oc-mm-tab="' + r + '"]').setAttribute('aria-selected', r === step ? 'true' : 'false');
      qs('[data-oc-mm-panel="' + r + '"]').hidden = r !== step;
    });
    if (scroll) {
      var tabs = qs('.oc-mm_tabs');
      var y = tabs.getBoundingClientRect().top + window.scrollY - stickyOffset() - 12;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  qsa('[data-oc-mm-tab]').forEach(function (t) {
    t.addEventListener('click', function () { goTo(t.getAttribute('data-oc-mm-tab'), false); });
  });
  qsa('[data-oc-mm-goto]').forEach(function (b) {
    b.addEventListener('click', function () { goTo(b.getAttribute('data-oc-mm-goto'), true); });
  });
  qs('[data-oc-mm-next]').addEventListener('click', function () { goTo('vase', true); });
  qsa('[data-oc-mm-more]').forEach(function (b) {
    b.addEventListener('click', function () {
      var role = b.getAttribute('data-oc-mm-more');
      state.shown[role] += PAGE_SIZE;
      applyFilter(role);
    });
  });

  /* Kaufleiste: Button führt bei unvollständiger Auswahl zum fehlenden Schritt */
  qs('[data-oc-mm-add]').addEventListener('click', function () {
    var s = state.sel.strauss, v = state.sel.vase;
    if (!s) return goTo('strauss', true);
    if (!v) return goTo('vase', true);
    addToCart();
  });

  /* ---------- Warenkorb ---------- */
  var routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function showError(msg) {
    var e = qs('[data-oc-mm-error]');
    e.textContent = msg; e.hidden = false;
  }

  function cartHas(cart, variantId, pairId) {
    return (cart.items || []).some(function (it) {
      return it.variant_id === variantId && it.properties && it.properties._mm_pair === pairId;
    });
  }

  function addToCart() {
    var s = state.sel.strauss, v = state.sel.vase;
    if (!s || !v || state.busy) return;
    var btn = qs('[data-oc-mm-add]');
    state.busy = true; btn.disabled = true; btn.classList.add('is-busy');
    qs('[data-oc-mm-cta-label]').textContent = 'Wird hinzugefügt …';
    var pairId = 'mm-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
    var props = function (role) { return { _mm_pair: pairId, _mm_role: role, _mm_set: SET_NAME }; };
    var payload = { items: [
      { id: s.variant.id, quantity: 1, properties: props('strauss') },
      { id: v.variant.id, quantity: 1, properties: props('vase') }
    ] };

    fetch(routeRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, body: j }; });
    }).then(function (res) {
      /* Erfolg nur, wenn beide Varianten wirklich im Warenkorb liegen */
      return fetch(routeRoot + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var both = cartHas(cart, s.variant.id, pairId) && cartHas(cart, v.variant.id, pairId);
        if (!both) {
          var msg = (res.body && (res.body.description || res.body.message)) || 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.';
          throw new Error(msg);
        }
        try {
          window.dispatchEvent(new CustomEvent('cartupdated', { bubbles: true }));
          window.dispatchEvent(new CustomEvent('toggleminicart', { bubbles: true }));
        } catch (e) {}
        closeSummary();
        qs('[data-oc-mm-cta-label]').textContent = 'Liegt im Warenkorb';
        setTimeout(function () { state.busy = false; btn.classList.remove('is-busy'); update(); }, 1500);
      });
    }).catch(function (err) {
      state.busy = false; btn.classList.remove('is-busy');
      update();
      showError(err && err.message ? err.message : 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.');
    });
  }

  /* ---------- Init ---------- */
  ROLES.forEach(renderGrid);
  update();
  try { if (window.ocPromo && window.ocPromo.onChange) window.ocPromo.onChange(update); } catch (e) {}
  ROLES.forEach(watchHint);

  /* Vorauswahl per URL (Link vom Produktseiten-Banner: /pages/bloom-mix-match?strauss=<handle>)
     und „Zurück“: zum verlinkten Produkt, sonst zur Vorseite (gleiche Domain), sonst Fallback aus den Einstellungen. */
  var params = new URLSearchParams(window.location.search);
  var back = qs('[data-oc-mm-back]');
  var fromProduct = null;
  state.preselecting = true;
  ROLES.forEach(function (role) {
    var h = params.get(role);
    if (!h) return;
    var p = products.filter(function (x) { return x.role === role && x.handle === h; })[0];
    if (!p) return;
    var idx = products.filter(function (x) { return x.role === role; }).indexOf(p);
    if (idx >= state.shown[role]) { state.shown[role] = idx + 1; renderGrid(role); }
    var node = qs('[data-oc-mm-grid="' + role + '"] .oc-mm_card[data-id="' + p.id + '"]');
    if (node && p.available) { select(role, p, node); fromProduct = p; }
  });
  state.preselecting = false;
  if (back) {
    if (fromProduct) {
      back.href = fromProduct.url;
      qs('[data-oc-mm-back-label]').textContent = 'Zurück zum Produkt';
    } else if (document.referrer && document.referrer.indexOf(window.location.origin) === 0 && history.length > 1) {
      back.addEventListener('click', function (e) { e.preventDefault(); history.back(); });
    }
  }
})();
